import { render, staticRenderFns } from "./AreaSlider.vue?vue&type=template&id=bb5cd9c0&"
import script from "./AreaSlider.vue?vue&type=script&lang=js&"
export * from "./AreaSlider.vue?vue&type=script&lang=js&"
import style0 from "./AreaSlider.vue?vue&type=style&index=0&id=bb5cd9c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports